import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from 'pages/thermography/config/store';

const PrivateRoute = () => {
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
